// extracted by mini-css-extract-plugin
export default {"main-grid":"GridGallery_main-grid__G-tnv","grid-image":"GridGallery_grid-image__zS-Hh"};